import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Lottie from 'react-lottie';
import * as waiting from 'Public/loaders/waiting';
import * as loading from 'Public/loaders/loading';
import * as success from 'Public/loaders/success';
import * as fail from 'Public/loaders/fail';
import * as rocket from 'Public/loaders/rocket';
import * as predicta from 'Public/loaders/predicta-money-anim-optimized';
import * as suggestionPredicta from 'Public/loaders/predicta-suggestion-anim';
import * as bahistaLoading from 'Public/loaders/bahista-loading';
import * as bahistaWriting from 'Public/loaders/bahista-writing';

class LottieLoader extends Component {
  static propTypes = {
    type: PropTypes.string.isRequired,
    className: PropTypes.string,
    width: PropTypes.string,
    height: PropTypes.string,
    isStopped: PropTypes.func,
    isPaused: PropTypes.func,
    loop: PropTypes.bool,
    autoplay: PropTypes.bool
  };

  _setDefaultOptions = () => {
    const { type, loop, autoplay } = this.props;
    let animationData;
    let preserveAspectRatio = 'xMidYMid slice';

    switch (type) {
      case 'waiting':
        animationData = waiting;
        break;
      case 'loading':
        animationData = loading;
        break;
      case 'success':
        animationData = success;
        break;
      case 'fail':
        animationData = fail;
        break;
      case 'rocket':
        animationData = rocket;
        break;
      case 'predicta':
        animationData = predicta;
        break;
      case 'suggestionPredicta':
        animationData = suggestionPredicta;
        break;
      case 'bahistaLoadingAnaliz':
        animationData = bahistaLoading;
        // Geniş loading satırı kırpılmasın (icon + metin)
        preserveAspectRatio = 'xMinYMid meet';
        break;
      case 'bahistaWriting':
        animationData = bahistaWriting;
        // Üç nokta kırpılmadan, oran korunarak
        preserveAspectRatio = 'xMidYMid meet';
        break;
      default:
        break;
    }

    return {
      loop: loop,
      autoplay: autoplay,
      animationData: animationData.default,
      rendererSettings: {
        preserveAspectRatio
      }
    };
  };

  render () {
    const {
      className,
      width,
      height,
      isStopped,
      isPaused,
    } = this.props;

    const defaultOptions = this._setDefaultOptions();

    return (
      <div className={ className }>
        <Lottie
          options={ defaultOptions }
          width={ width }
          height={ height }
          isStopped={ isStopped }
          isPaused={ isPaused }
        />
      </div>
    );
  }
}

export default LottieLoader;

/**
* @npm      : https://www.npmjs.com/package/react-lottie
* @whatFor  : allows to use loaders with JSON file. check ..../public/loaders/success.json files
* @usage    : <LottieLoader type="success" loop={ false } autoplay width="30%" /> etc...
*/
